// extracted by mini-css-extract-plugin
export default {"root":"Checkbox_root__aDiG8","input":"Checkbox_input__aVJKP","box":"Checkbox_box__ZAzdO","label":"Checkbox_label__9F+bT"};